var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenNib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen-nib"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87101 2C10.0478 2 10.2174 2.07024 10.3424 2.19526L13.8047 5.65762C14.0651 5.91797 14.0651 6.34008 13.8047 6.60043L12.065 8.3402C11.94 8.46522 11.7704 8.53546 11.5936 8.53546C11.5741 8.53546 11.5548 8.53461 11.5356 8.53294L10.4859 11.3311C10.4167 11.5155 10.2696 11.6599 10.0838 11.7255L3.75453 13.9619C3.51238 14.0475 3.24261 13.9863 3.06101 13.8047L2.19526 12.939C2.01366 12.7574 1.95253 12.4876 2.03808 12.2455L4.27447 5.91609C4.34009 5.73037 4.48448 5.58317 4.6689 5.51399L7.4671 4.46431C7.4507 4.27496 7.51495 4.07994 7.65986 3.93503L9.39961 2.19526C9.52463 2.07024 9.6942 2 9.87101 2ZM11.5936 6.92598L12.3905 6.12903L9.87101 3.60948L9.07407 4.40644L11.5936 6.92598ZM8.34165 5.56031L5.42812 6.65325L3.80216 11.255L6.46003 8.59711C6.72038 8.33676 7.14249 8.33676 7.40284 8.5971C7.66319 8.85745 7.6632 9.27956 7.40285 9.53991L4.74496 12.1978L9.34667 10.5719L10.4396 7.65829L8.34165 5.56031Z",
    fill: "#4A5565"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenNib);
export default __webpack_public_path__ + "static/media/pen-nib.a6e07649f6219fce868e2b52afe7e8df.svg";
export { ForwardRef as ReactComponent };